/* eslint-disable no-nested-ternary */
import React from 'react';
import { Modal } from 'fpay-ui';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ModalPopUpTable from '@components/Modal/ModalPopUpTable';
import ErrorAdvancement from '@components/ErrorAdvancement';

import {
  getFormatedDate,
  getFormatedType,
  getFormatedMoneyIn,
  getFormatedMoneyOut,
} from '@helpers/andesUtils';

import { TYPE_MOVEMENT_AUTHORIZATION } from '@constants/transactions';
import { isCountryColombia } from 'constants/regions';
import ModalAdvancements from '../Modal/ModalAdvancements';
import { Spinner } from '../Spinner/SpinnerWithLessStyle';

const ModalLastMovementsTable = ({
  open,
  onClose,
  idToShow,
  breakpoint,
  getFondsOutByAuthorization,
}) => {
  const { t } = useTranslation();

  const advancementsData = useSelector(
    (state) => state.advancements?.advancementDetails?.advancements?.[0]
  );

  const errorAdvancement = useSelector((state) => state.advancements?.advancementError);

  if (!open || !idToShow) return null;

  const isAdvancementTEDCashIn =
    idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS;

  return (
    <Modal fClose={onClose} width={breakpoint === 'xs' ? '312px' : '344px'}>
      {isAdvancementTEDCashIn ? (
        errorAdvancement ? (
          <ErrorAdvancement />
        ) : advancementsData ? (
          <ModalAdvancements
            date={getFormatedDate(idToShow.event_date)}
            code={idToShow.id}
            description={t(getFondsOutByAuthorization(idToShow))}
            advancedDiscountAmount={advancementsData?.advanced_discount_amount}
            advancedGrossAmount={advancementsData?.advanced_gross_amount}
            advancedNetAmount={advancementsData?.advanced_net_amount}
            discountRate={advancementsData?.discount_rate}
          />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="255px">
            <Spinner />
          </Box>
        )
      ) : (
        <ModalPopUpTable
          description={t(getFondsOutByAuthorization(idToShow))}
          type={
            isCountryColombia && getFormatedType(idToShow.type) === 'Ingreso'
              ? 'Entrada'
              : isCountryColombia && getFormatedType(idToShow.type) === 'Egreso'
              ? 'Salida'
              : getFormatedType(idToShow.type)
          }
          mount={
            idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN ||
            idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS ||
            idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO ||
            idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO ||
            idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO ||
            idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO
              ? getFormatedMoneyIn(idToShow.amount)
              : getFormatedMoneyOut(idToShow.amount)
          }
          date={getFormatedDate(idToShow.event_date)}
          code={idToShow.id}
        />
      )}
    </Modal>
  );
};

export default ModalLastMovementsTable;
